import { footer } from "framer-motion/client";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.svg";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footerBlock">
          <div className="footerInfo">
            <div className="footerInfoBox">
              <img src={logo} alt="logo" />
            </div>
            <div className="footerInfoBox">
              <h3>Контакты</h3>
              <a href="mailto:info@aitiguru.ru">info@aitiguru.ru</a>
              <a href="tel:+74992800001">+7 (499) 280-00-01</a>
              <div className="socialBlock">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btnTg"
                ></a>
              </div>
            </div>
            <div className="footerInfoBox">
              <h3>Навигация</h3>
              <ul className="footerMenu">
                <li className="nav-item">
                  <a href="#" className="nav-link active">
                    Главная
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    Услуги
                  </a>
                </li>
                <li className="nav-item">
                  <Link to="/cases" className="nav-link">
                    Кейсы
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/team" className="nav-link">
                    Наша команда
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footerInfoBox">
              <h3>Информация</h3>
              <ul className="footerMenu">
                <li className="nav-item">
                  <Link to="/politica" className="nav-link">
                    Политика конфиденциальности
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/soglashenie" className="nav-link">
                    Условия соглашения
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="footerBottom">
              <p>©2025. AitiGuru</p>
              <p>
                108802, г. Москва, вн.тер.г. поселение Сосенское, д. Сосенки,
                ул. Ясеневая, д. 3, эт/пом/ком 1/1/11
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
